"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modules = void 0;
//@ts-check
require("./_globals");
var constructors = require("./constructors");
var grammar = require("./grammar");
var indexing = require("./indexing");
var random = require("./random");
var statistics = require("./statistics");
exports.modules = {
    constructors: constructors,
    grammar: grammar,
    random: random,
    indexing: indexing,
    statistics: statistics,
};
